<div class="rd-widget rd-widget-no-height-restriction value-conclusion-table-widget widget-{{widgetConfig.widgetId}}">
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr class="value-conclusion-table-widget-header">
        <td colspan="12">
          {{'valueConclusionTable.labelAppraisalPremise' | rdTranslate}}
        </td>
        <td colspan="7">
          {{'valueConclusionTable.labelInterestAppraised' | rdTranslate}}
        </td>
        <td colspan="7">
          {{'valueConclusionTable.labelDateOfValue' | rdTranslate}}
        </td>
        <td colspan="7">
          {{'valueConclusionTable.labeValueConclusion' | rdTranslate}}
        </td>
      </tr>
    </thead>
    <tbody>
      <ng-template [ngIf]="editMode">
        <tr>
          <td colspan="12">
            <kendo-dropdownlist [data]="reflists['ref_l3_appraisal_premise']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetConfig.widgetSettings.appraisalPremise"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="7">
            <kendo-dropdownlist [data]="reflists['ref_l3_interest_appraised']" style="width:100%" class="widget-input-text"
                                textField="description"
                                valueField="oid"
                                [valuePrimitive]="true"
                                [(ngModel)]="widgetConfig.widgetSettings.interestAppraised"
                                (ngModelChange)="setDirtyFlag(true)">
            </kendo-dropdownlist>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" class="title-date" *ngIf="data.dateOfValue" [color]="'black'">{{data.dateOfValue | rdLocalizedDate}}</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" [color]="'black'">{{currency}} {{(data.valueConclusion || 0) | rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </ng-template>
      <ng-template [ngIf]="!editMode">
        <tr>
          <td colspan="12">
            <widget-value [align]="'left'" class="title-date" [color]="'black'">{{ widgetConfig.widgetSettings.appraisalPremise | rdReflist: reflists['ref_l3_appraisal_premise']}}</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" class="title-date" [color]="'black'">{{ widgetConfig.widgetSettings.interestAppraised | rdReflist: reflists['ref_l3_interest_appraised']}}</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" class="title-date" *ngIf="data.dateOfValue" [color]="'black'">{{data.dateOfValue | rdLocalizedDate}}</widget-value>
          </td>
          <td colspan="7">
            <widget-value [align]="'left'" [color]="'black'">{{currency}} {{(data.valueConclusion || 0) | rdLocalizedNumber:0}}</widget-value>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>
